import { Route, Routes } from "react-router-dom";
import Bookings from "./pages/Bookings/Bookings";
import UserSignIn from "./pages/UserSignIn/UserSignIn";
import { useMediaQuery } from 'react-responsive';
import HotelView from "./pages/HotelView/HotelView";
import CabDecesion from "./pages/CabBooking/CabDecesion/CabDecesion";
import WebCheckIn from "./pages/WebCheckIn/WebCheckIn";
import EditWebCheckIn from "./pages/WebCheckIn/EditWebCheckIn/EditWebCheckIn";

import { store } from "./redux/store";
import {Provider} from "react-redux";

import EditCabBooking from "./pages/CabBooking/EditCabBooking/EditCabBooking";
import UpdateCabBooking from "./pages/CabBooking/UpdateCabBooking";
import UpdateWebCheckIn from "./pages/WebCheckIn/UpdateWebCheckIn/UpdateWebCheckIn";
import RequestUpdateCheckIn from "./pages/WebCheckIn/UpdateWebCheckIn/RequestUpdateCheckIn/RequestUpdateCheckIn";

// For Toast message 
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FoodSummary from "./pages/PostCheckInRequest/FoodSummary/FoodSummary";
import SpaSummary from "./pages/PostCheckInRequest/Spa/SpaSummary/SpaSummary";
import EditUserProfile from "./pages/EditUserProfile/EditUserProfile";
import HotelGuidelines from "./pages/HotelGuidelines/HotelGuidelines";
import CheckOutPay from "./pages/PostCheckInRequest/CheckOut/CheckOutPay/CheckOutPay";
import Discount from "./pages/Discount/Discount";
import RestaurantDining from "./pages/RestaurantDining/RestaurantDining";
import WebCheckInTags from "./pages/WebCheckIn/WebCheckinTags/WebCheckInTags";
import WebCheckInSuccess from "./pages/WebCheckIn/WebCheckInSuccess/WebCheckInSuccess";
import UpdateWebCheckIntags from "./pages/WebCheckIn/UpdateWebCheckIn/UpdateWebCheckinTags/UpdateWebCheckIntags";
import RequestLink from "./pages/RequestLink/RequestLink";
import NewRequest from "./pages/NewRequest/NewRequest";
 

function App() {
  const isMobile = useMediaQuery({ maxWidth: 767 });

 
  return (
    <>
      {isMobile ? (
        <Provider store={store}>
          <ToastContainer />
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<UserSignIn />} />
            <Route path="/bookings" element={<Bookings/>} />
            <Route path="/bookings/:bookingId" element={<HotelView/>} />
            <Route path="/editUserProfile" element={<EditUserProfile/>} />
            <Route path="/hotelGuidelines" element={<HotelGuidelines/>} />

            {/* Raising a request under a booking */}
            <Route path="/bookings/:bookingId/requests/new/:service" element={<NewRequest/>} />


            {/* PreCheckIn */}
            <Route path="/editCabBooking" element = {<EditCabBooking/>} />
            <Route path="/updateCabBooking" element ={<UpdateCabBooking/>} />
            <Route path="/cabDecesion" element={<CabDecesion/>} />
            <Route path="/webCheckIn" element={<WebCheckIn/>} />
            <Route path="/editWebCheckIn" element={<EditWebCheckIn/>} />
            <Route path="/webCheckInTags" element = {<WebCheckInTags/>}/>
            <Route path="/updateWebCheckIn" element = {<UpdateWebCheckIn/>} />
            <Route path="/requestUpdateCheckIn" element = {<RequestUpdateCheckIn/>} />
            <Route path="/webCheckInSuccess" element = {<WebCheckInSuccess/>} />
            <Route path="/updateWebCheckinTags" element = {<UpdateWebCheckIntags/>} />


            {/* Post CheckIn */}

            {/* Food Request */}
            <Route path="/foodSummary" element={<FoodSummary/>}/>

            {/* HouseKeeping */}

            {/* Taxi */}

            {/* Table Booking */}


            {/* Wake Up Call */}

            {/* Room Change */}

            {/* Custom Request */}

            {/* Conference Room */}

            {/* Late Checkout */}

            {/* Wifi Request */}

            {/* Spa Request */}
            <Route path="/spaSummary" element={<SpaSummary/>} />

            {/* CheckOut Request */}
            <Route path="/checkoutPay" element={<CheckOutPay/>} />


            {/* Discount */}
            <Route path="/discount" element={<Discount/>} />

            {/* Request deep link (sent to guests when a request completes) */}
            <Route path="/requests/:requestId" element={<RequestLink/>} />

            <Route
              path="/hotels/:hotelId/table/:tableId"
              element={
                <RestaurantDining />
              }
            />

          </Routes>
        </Provider>
      ) : (
        <div
          style={{
            padding: "10px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            fontFamily: "'Manrope', sans-serif",
            textTransform: "capitalize",
            height: "100vh",
          }}
        >
          <h1>This app currently only works in mobile layout</h1>
        </div>
      )}
    </>
  );
}

export default App;
